// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './ContactSection.module.scss';
import classNames from 'classnames';

const ContactSection: PageComponent = () => {
    // TODO: check responsive
    return (
        <section className={`container ${styles.section}`}>
            <div className={styles.background_diamonds}>
                <h1 className={styles.title}>
                    <Trans i18nKey="liveHelp.title" ns="landingHelpFaq">
                        Pagalba gyvai
                    </Trans>
                </h1>
                <p>
                    <Trans i18nKey="liveHelp.description" ns="landingHelpFaq">
                        Neradote atsakymo į Jūsų klausimą? Pabendraukime gyvai
                    </Trans>
                </p>
                <div className={styles.options}>
                    <a href="tel:+37067174997">
                        <img src="/static/img/icons/phone.svg" />
                        +370 671 74997
                    </a>
                    <a href="mailto:info@vpsnet.com">
                        <img src="/static/img/icons/email.svg" />
                        info@vpsnet.com
                    </a>
                </div>
                <button
                    type="submit"
                    className={classNames(`btn btn-primary col-sm-4`, styles.livehelp_btn)}
                    onClick={(e) => {
                        e.preventDefault();
                        if (window['$_LHC']) {
                            window['$_LHC'].eventListener.emitEvent(
                                'showWidget',
                            );
                        }
                    }}
                >
                    <Trans i18nKey="liveHelp.button" ns="landingHelpFaq">
                        Pradeti
                    </Trans>
                </button>
            </div>
        </section>
    );
};

export default ContactSection;
